import {API_HOST} from "@/core/variables";
import axios from "axios";

class SubscriptionTransactionRepository {
    async read(id: string) {
        return axios.get(`${API_HOST}/v1/subscription-transaction/${id}`)
    }

    async find(
        workspaceName?: string,
        planName?: string,
        startDate?: string,
        endDate?: string,
        skip?: number,
        limit?: number
    ) {
        return axios.get(`${API_HOST}/v1/subscription-transaction`, {
            params: {
                workspaceName,
                planName,
                startDate,
                endDate,
                skip,
                limit
            }
        })
    }

    async downloadCSV(
        workspaceName?: string,
        planName?: string,
        startDate?: string,
        endDate?: string,
    ) {
        return axios.get(`${API_HOST}/v1/subscription-transaction/export`, {
            params: {
                workspaceName,
                planName,
                startDate,
                endDate,
            }
        })
    }
}

const subscriptionTransactionRepository = new SubscriptionTransactionRepository();

export default subscriptionTransactionRepository;
